/**
 * useTodoFetching — Low-level todo fetching with nested subtask joins.
 */
import { supabase, withSessionSetup } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export const useTodoFetching = () => {
  const { user } = useAuth();
  
  const fetchUserTodos = async () => {
    if (!user) return [];
    
    // Use the withSessionSetup helper to ensure session is properly set up
    const result = await withSessionSetup(async () => {
      const { data, error } = await supabase
        .from('todos')
        .select(`
          id,
          text,
          completed,
          due_date,
          goal_id,
          subtasks (
            id,
            text,
            completed,
            due_date,
            sub_subtasks (
              id,
              text,
              completed
            )
          )
        `);
        
      if (error) throw error;
      return data;
    });
    
    return result || [];
  };

  return {
    fetchUserTodos
  };
};
